// extracted by mini-css-extract-plugin
export var container = "_ex-1";
export var cornerButtonContainer = "_ex-6";
export var disabled = "_ex-2";
export var dragActive = "_ex-3";
export var fileContainer = "_ex-5";
export var hiddenInput = "_ex-4";
export var widthContainer = "_ex-0";